var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChangeHistory = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_187_48",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_187_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.80001 20C3.41667 20 3.12501 19.8292 2.92501 19.4875C2.72501 19.1458 2.73334 18.8083 2.95001 18.475L11.15 5.35C11.35 5.03333 11.6333 4.875 12 4.875C12.3667 4.875 12.65 5.03333 12.85 5.35L21.05 18.475C21.2667 18.8083 21.275 19.1458 21.075 19.4875C20.875 19.8292 20.5833 20 20.2 20H3.80001ZM5.60001 18H18.4L12 7.75L5.60001 18Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChangeHistory);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/change_history.73902fdeacdb46907037b2ec4bdd72a2.svg";